import * as types from '@/store/types'
import Vue from 'vue'
export default {
    changeStatusLoaded: (context, payload) => {
        context.loaded = payload
    },
    lastDialogs: (context, payload) => {
        context.messagesDialog = payload
    },
    loadMessagesChat: (context, payload) => {
        context.messagesDialogChat = payload
    }
}
